import slugify from './slugify';

export { slugify };
